import version from './version';
export default "data-dui-" + version.replace(/\./g, '-');
